import { Navigate, useParams } from 'react-router-dom'
import { useReadApplication } from '@/api/financial/application/read-application'
import { routes } from '@/routes'
import { AllowanceJourneyPage } from './allowance/allowance-journey.page'
import { InternshipJourneyPage } from './internship/internship-journey.page'
import { PersonalLoanJourneyPage } from './personal-loan/personal-loan-journey.page'
import { JourneySkeleton } from '@/components/credit-journey/journey-skeleton'

/** Cada produto tem a própria jornada de solicitação. */
export function CreditApplicationPage() {
  const { application_key: applicationKey = '' } = useParams()
  const application = useReadApplication(applicationKey)

  if (!applicationKey) return <Navigate to={routes.credit.index} replace />
  if (application.isLoading || !application.data) {
    return <JourneySkeleton />
  }
  if (application.data.product === 'internship') {
    return <InternshipJourneyPage key={applicationKey} />
  }
  if (application.data.product === 'personal_loan') {
    return <PersonalLoanJourneyPage key={applicationKey} />
  }
  return <AllowanceJourneyPage key={applicationKey} />
}
